
const digest = '5661b68ef11b99f987b986ef081eb6396b89b9d3ae6efb94d2a6297f8ffefcb0';
const classes = {"wrapper":"_wrapper_3638e_1","childrenWrapper":"_childrenWrapper_3638e_7","item":"_item_3638e_14","content":"_content_3638e_36","control":"_control_3638e_44","caseType":"_caseType_3638e_47","mainFolder":"_mainFolder_3638e_50"};
const css = `._wrapper_3638e_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_3638e_1 ._childrenWrapper_3638e_7 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 20px;
  margin-left: 35px;
}
._wrapper_3638e_1 ._childrenWrapper_3638e_7 ._item_3638e_14:before {
  content: "";
  height: 55%;
  width: 15px;
  border-left: 1px solid #c6c6c6;
  border-bottom: 1px solid #c6c6c6;
  position: absolute;
  left: -20px;
  top: 0;
}
._wrapper_3638e_1 ._item_3638e_14 {
  padding: 12px;
  background-color: #ffffff;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_3638e_1 ._item_3638e_14 ._content_3638e_36 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  align-items: center;
  padding: 12px;
}
._wrapper_3638e_1 ._item_3638e_14 ._control_3638e_44 {
  padding-right: 12px;
}
._wrapper_3638e_1 ._item_3638e_14._caseType_3638e_47 {
  color: #1665d8;
}
._wrapper_3638e_1 ._item_3638e_14._mainFolder_3638e_50 {
  background-color: #fbfbfd;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  